<template>
  <ul class="gnb">
<!--    <li>-->
<!--      <a href="http://gynpadmall.com/hospital/search.html" target="_blank">상담 병원 찾기</a>-->
<!--    </li>-->
    <li>
      <router-link to="/about">GYNPAD</router-link>
    </li>
    <li @mouseover="d1over" @mouseout="d1out">
      <router-link @click.native="d1click" to="/campaign" event="none">CAMPAIGN</router-link>
      <ul>
        <li>
          <router-link to="/campaign/gyn-story">가인 스토리</router-link>
        </li>
      </ul>
    </li>
    <li @mouseover="d1over" @mouseout="d1out">
      <router-link @click.native="d1click" to="/board" event="none">NEWS & EVENT</router-link>
      <ul>
        <li>
          <router-link to="/board/news">NEWS</router-link>
        </li>
        <li>
          <router-link to="/board/event">EVENT</router-link>
        </li>
      </ul>
    </li>
    <li><router-link to="/counseling">COUNSELING</router-link></li>
    <li><router-link to="/notice">NOTICE</router-link></li>
    <li class="hidden-md-down lang tc">
      <a href="http://gynpadmall.com" target="_blank">구매하기</a>
<!--      <a href="http://gynpadmall.com/hospital/search.html" target="_blank" class="mt-10">상담 병원 찾기</a>-->
    </li>
    <li class="hidden-md-down lang tc ml-10">
      <a href="http://gynpadmall.com/hospital/search.html" target="_blank">상담 병원 찾기</a>
    </li>
  </ul>
</template>

<style lang="less">
  @import "../less/asset";
  @import "../less/gynpad";

  .gnb {
    & > li {
      & > a { .karla; .rh(64); .lh-r(64); .fs(2.5rem); .block; }
      & > ul { background: @c-bg; .rp-v(10); .hide();
        & > li {
          & > a { .notokr; .fs(1.5rem); .lh-r(40); .block; }
        }
      }
      &.on > ul { .block; }
    }
  }
  @media (min-width: @screen-lg-min) {
    .gnb {
      & > li { .ib; .igap-h(50px); .vat;
        & > a { .fsl(1rem, 50px); .h(50px); .vam; .rel;
          &.router-link-active:after, &:hover:after { content:''; height:2px; background: #f85c70; .block; .lb(0,15px); width: 100%; }
        }
        & > ul { background: none; .abs;
          & > li {
            & > a { .notokr; .fsl(1rem,2); }
          }
        }
        &.on {
          & > a:after { content:''; height:2px; background: #f85c70; .block; .lb(0,15px); width: 100%; }
          & > ul { .block; margin-top: -15px; }
        }
        &.lang {
          a { color: #fff; background: #f85c70; padding: 0 15px; font-size: 15px; .block;
            &:hover:after { .hide; }
          }
        }
      }
    }
  }
</style>

<script>
import { isTouch, toggleClass, addClass, removeClass } from '../util';

export default {
  name: 'Gnb',
  data() {
    return {
    };
  },
  methods: {
    d1click(event) {
      const t = event.currentTarget;
      if (isTouch()) {
        toggleClass(t.parentNode, 'on');
      } else {
        this.$router.push(t.getAttribute('href'));
      }
    },
    d1over(event) {
      if (isTouch()) return;
      addClass(event.currentTarget, 'on');
    },
    d1out(event) {
      if (isTouch()) return;
      removeClass(event.currentTarget, 'on');
    },
  },
  mounted() {
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Gnb.vue